import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DateFeedbackModal from './DateFeedbackModal';
import { getDatePlans } from '../lib/api';

/**
 * Global listener that opens the DateFeedbackModal when the URL contains
 * `?postDateFeedback=<datePlanId>&matchId=<matchId>` — used by the post-date
 * reminder notification (`date_recap_reminder`) and the recap CTA button.
 */
export default function PostDateFeedbackHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const [datePlan, setDatePlan] = useState<any | null>(null);

  const close = useCallback(() => {
    setDatePlan(null);
    // Strip the query params so the modal doesn't re-open on next render
    const params = new URLSearchParams(location.search);
    params.delete('postDateFeedback');
    params.delete('matchId');
    const newSearch = params.toString();
    navigate({ pathname: location.pathname, search: newSearch ? `?${newSearch}` : '' }, { replace: true });
  }, [location, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const planId = params.get('postDateFeedback');
    const matchId = params.get('matchId');
    if (!planId || !matchId) {
      setDatePlan(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await getDatePlans();
        const plans: any[] = res.data || [];
        const found = plans.find((p) => p.id === planId);
        if (cancelled) return;
        if (found) {
          setDatePlan({ ...found, match_id: found.match_id || matchId });
        } else {
          // Plan not in active list (could be in past_dates) — minimal stub still works
          setDatePlan({ id: planId, match_id: matchId });
        }
      } catch {
        setDatePlan({ id: planId, match_id: matchId });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.search]);

  if (!datePlan) return null;
  return <DateFeedbackModal datePlan={datePlan} onClose={close} onSubmitted={close} />;
}
